'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotebookMIconIcon = function NotebookMIconIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M27.625 32H5.812a.722.722 0 0 1-.75-.75V.75c0-.438.313-.75.75-.75h21.813c.438 0 .75.313.75.75v30.5c0 .438-.313.75-.75.75zM6.563 30.563h20.375V1.438H6.563zm.687-24.75H4.375c-.438 0-.75-.313-.75-.75s.313-.688.75-.688H7.25c.438 0 .75.25.75.688s-.313.75-.75.75zm0 4.375H4.375c-.438 0-.75-.313-.75-.75s.313-.688.75-.688H7.25c.438 0 .75.25.75.688s-.313.75-.75.75zm0 4.375H4.375c-.438 0-.75-.313-.75-.75s.313-.75.75-.75H7.25c.438 0 .75.313.75.75s-.313.75-.75.75zm0 4.375H4.375c-.438 0-.75-.313-.75-.75s.313-.75.75-.75H7.25c.438 0 .75.313.75.75s-.313.75-.75.75zm0 4.312H4.375c-.438 0-.75-.25-.75-.688s.313-.75.75-.75H7.25c.438 0 .75.313.75.75s-.313.688-.75.688zm0 4.375H4.375c-.438 0-.75-.25-.75-.688s.313-.75.75-.75H7.25c.438 0 .75.313.75.75s-.313.688-.75.688zm5.813-6.125v-11h2.188l2.625 7.813c.313.75.438 1.313.625 1.625.125-.438.25-1 .563-1.75l2.625-7.688h1.875v11h-1.438v-9.313l-3.188 9.188H17.75l-3.188-9.313V21.5zm-3.625-2h2.063v2H9.438z' })
    );
};

exports.default = NotebookMIconIcon;